<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'dataconnection.template.title'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
      <app-datatable [dataSource]="source"
                    [columns]="columns"
                    [identifier]="'dataconnectionTemplates'"
                    [customActions]="customActions"
                    [customTableActions]="customTableActions"
                    (newEvent)="new()"
                    (showEvent)="show($event.valueOf())">
                      <app-empty-table [icon]="'settings_input_component'"
                        [emptyText]="'dataconnection.template.empty-text' | translate"
                        [buttonText]="'createNew' | translate"
                        (btnClick)="new()">
                      </app-empty-table>
      </app-datatable>

      <input #fileInput (change)="importFile($event)" class="d-none" type="file" accept=".json">
      <app-error [error]="error"></app-error>
  </div>
</div>
